import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import './i18n'; // Initialize i18n
import './utils/errorSuppression'; // Suppress benign ResizeObserver errors
import logger from './utils/logger';

// Send httpOnly auth cookie with every API request (enables /auth/session-restore and /auth/me)
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the minimal installable service worker (passthrough fetch handler).
// Required for Chrome's "Add to Home Screen" install prompt.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      logger.error('SW registration failed', err);
    });
  });
}
